import { type Candidate, type LanguageProficiency } from "@vidario/domain";
import { Card } from "@vidario/ui";
import { type ReactElement } from "react";

const PROFICIENCY_LABELS: Record<LanguageProficiency, string> = {
  native: "Muttersprache",
  fluent: "Verhandlungssicher",
  professional: "Fließend",
  conversational: "Konversation",
  basic: "Grundkenntnisse",
};

/** Languages with proficiency. From the LinkedIn-enrichment Claude
 * prompt — Finding 5. Renders as a chip row. */
export function LanguagesCard({
  candidate,
}: {
  candidate: Candidate;
}): ReactElement | null {
  if (candidate.languages.length === 0) return null;
  return (
    <Card>
      <h3 className="m-0 mb-3 text-[15px] font-semibold">Sprachen</h3>
      <ul className="m-0 flex list-none flex-wrap gap-2 p-0">
        {candidate.languages.map((lang, i) => {
          const proficiencyLabel =
            lang.proficiency !== ""
              ? PROFICIENCY_LABELS[lang.proficiency as LanguageProficiency]
              : null;
          return (
            <li
              key={`${lang.name}-${i}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-border-default bg-neutral-50 px-2.5 py-1 text-[13px]"
            >
              <span className="font-medium">{lang.name}</span>
              {proficiencyLabel && (
                <span className="text-text-tertiary">· {proficiencyLabel}</span>
              )}
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
